import collectionQuickview from "./collection-quickview";
import productItemApp from "./product-item-app";
import trapFocus from "./trap-focus";

function collectionFilters(opts) {
  const config = {
    dom: {
      collection: "collection",
      filtersWrapper: "filtersWrapper",
      filtersDrawerTrigger: "filtersDrawerTrigger",
      toolbar: "collectionToolbar",
      productsGrid: "productsGrid",
      desktopAppendWrapper: "desktopAppendWrapper",
      drawerClose: "filtersDrawerClose",
      filterGroup: "js-filter-group",
      filterGroupDisplay: "js-filter-group-display",
      filterGroupColors: "js-filter-group-colors",
      filterForm: "filterForm",
      appliedCount: "applyFiltersCount",
      clearAllMobile: "js-clear-all-mobile",
      modalFiltersOverlay: "modalFiltersOverlay",
      activeFiltersDisplay: "js-active-filter-size",
      activeFiltersDisplayDesktop: "js-active-filter-size-desktop",
      activeFiltersDisplayMobile: "active-fitlers-count--mobile",
      productSwatch: "js-product-swatch",
      productSwatchWrapper: "js-product-swatch-wrapper",
      desktopFilterForm: "desktopFilterForm",
      sidebarBtn: "js-filter-sidebar-btn",
      sidebarBtnAbs: "js-filter-sidebar-btn-abs",
      sidebarFilterGroup: "sidebar-filter-group",
      productsContainer: "js-products-container",
      filterGroupContainer: "js-filter-group-container",
      clearAllDesktop: "js-clear-all-desktop",
      activeFiltersCount: "filter-group-summary__active-filters-count"
    },
    cls: {
      active: "is-active",
      closed: "is-closed",
      hide: "hide",
      hideMobile: "hide-mobile",
      open: "is-open",
      selected: "is-selected",
      stuck: "is-stuck",
      fullWidth: "full-width",
      bodyNoScroll: "body--no-scroll",
      productsPerRowThree: "products-per-row--three",
      productsPerRowFour: "products-per-row--four",
      productsPerRowOne: "products-per-row--one"
    }
  };

  // Shorthand config
  const c = __.extend(config, opts); // Extend defaults with passed options

  // cached global(s)
  const $toolbar = document.getElementById(c.dom.toolbar);
  const $filtersWrapper = document.getElementById(c.dom.filtersWrapper);
  const $filtersTrigger = document.getElementById(c.dom.filtersDrawerTrigger);
  const $desktopAppendWrapper = document.getElementById(c.dom.desktopAppendWrapper);
  const $filterGroups = document.querySelectorAll(`.${c.dom.filterGroup}`);
  const $mobileFilterGroups = document.querySelectorAll(`.${c.dom.filterGroup}:not(.${c.dom.sidebarFilterGroup})`);
  const $desktopFilterGroups = document.querySelectorAll(`.${c.dom.filterGroup}.${c.dom.sidebarFilterGroup}`);
  const $appliedCount = document.getElementById(c.dom.appliedCount);
  const overlay = document.getElementById(c.dom.modalFiltersOverlay);
  const $desktopFilterForm = document.getElementById(c.dom.desktopFilterForm);
  const $sidebarBtn = document.querySelector(`.${c.dom.sidebarBtn}`);
  const $sidebarBtnAbs = [...document.querySelectorAll(`.${c.dom.sidebarBtnAbs}`)];
  const $productsGrid = document.getElementById(c.dom.productsGrid);
  const $productsContainer = document.querySelector(`.${c.dom.productsContainer}`);
  const $filterGroupContainer = document.querySelector(`.${c.dom.filterGroupContainer}`);
  const $filterForm = document.getElementById(c.dom.filterForm);
  const $desktopClearAllButton = [...document.querySelectorAll(`.${c.dom.clearAllDesktop}`)];
  const $filterContainersDisplayElements = [...document.querySelectorAll(`.${c.dom.activeFiltersDisplay}`)];

  const filters = new Set();
  let view;
  let formModified = false;

  /**
   * Init
   */
  function init() {
    if (!$toolbar) {return;}
    responsive();
    __.windowResize(responsive);
    addEvents();
    setActiveFiltersSize();
    setUpProductGrid();
    initSizeRangeInput();
    scrollToCollectionTop();
    addStickyScrollEvent();
  }

  /**
   * Scroll to Collection Top
   */
  function scrollToCollectionTop() {
    const { hash } = window.location;

    if (!hash) {
      return;
    }

    let $target = document.querySelector(hash);

    if (!$target) {
      $target = $toolbar || $productsGrid;
    }

    if (!$target) {
      return;
    }

    $target.scrollIntoView({ behavior: "smooth" });
  }

  /**
   * Add Sticky Scroll Event
   */
  function addStickyScrollEvent() {
    if (!$desktopFilterForm) {return;}

    handleStickyScroll();

    __.addEvent({
      id: document,
      event: "scroll",
      fn: handleStickyScroll
    });
  }

  /**
   * Handle Sticky Scroll
   */
  function handleStickyScroll() {
    if (!$desktopFilterForm || view === "mobile") {return;}

    const stickyTop = parseFloat(getComputedStyle($desktopFilterForm).top) || 0;
    const isStuck = $desktopFilterForm.getBoundingClientRect().top <= stickyTop;

    if (isStuck) {
      __.addClass($desktopFilterForm, c.cls.stuck);
    } else {
      __.removeClass($desktopFilterForm, c.cls.stuck);
    }
  }

  /**
   * Set Up Product Grid
   */
  function setUpProductGrid() {
    if (!$productsGrid) {return;}

    if (view === "desktop") {
      const { initialGridSize } = $productsGrid.dataset;
      if (initialGridSize === c.cls.productsPerRowFour) {
        return;
      }

      __.removeClass($productsGrid, c.cls.productsPerRowFour);
      __.addClass($productsGrid, c.cls.productsPerRowThree);
    } else if (view === "mobile") {
      __.addClass($productsGrid, c.cls.productsPerRowOne);
    }
  }

  /**
   * Get the active filter form root based on current view
   */
  function getActiveFilterContainer() {
    return view === "mobile" ? $filtersWrapper : $desktopFilterForm;
  }

  /**
   * Update active filters size
   */
  function updateActiveFiltersSize() {
    const $filterContainer = getActiveFilterContainer();
    if (!$filterContainer) {return;}
    const filterGroups = $filterContainer.querySelectorAll(`.${c.dom.filterGroup}`);
    filterGroups.forEach(group => {
      const activeCount = group.querySelectorAll('input[type="checkbox"]:checked').length;
      const countElement = group.querySelector(`.${c.dom.activeFiltersCount}`);
      if (countElement) {
        countElement.textContent = activeCount > 0 ? `(${activeCount})` : "";
      }
    });
  }

  /**
   * Set Active Filters Size
  */
 function setActiveFiltersSize() {
   const $filterContainer = getActiveFilterContainer();
   const activeFilters = $filterContainer ? $filterContainer.querySelectorAll('input[type="checkbox"]:checked') : [];
   const isDesktop = view !== "mobile";
   const mobileFilterDisplay = document.querySelector(`.${c.dom.activeFiltersDisplayMobile}`);
   updateActiveFiltersSize();
   if ($filterContainersDisplayElements?.length && activeFilters?.length) {
      $filterContainersDisplayElements.forEach(($filterContainersDisplayElement) => {
        if (isDesktop) {
          $desktopClearAllButton.forEach(($btn) => {
            $btn.classList.remove(c.cls.hide, c.cls.hideMobile);
          });
          $filterContainersDisplayElement.innerHTML = activeFilters?.length ? `&nbsp;(${activeFilters?.length})` : "";
        } else {
          mobileFilterDisplay.classList.remove(c.cls.hide);
          $filterContainersDisplayElement.innerHTML = activeFilters?.length;
        }
      });
    } else {
      $desktopClearAllButton.forEach(($btn) => {
        $btn.classList.add(c.cls.hide, c.cls.hideMobile);
      });
      if (isDesktop) {
        $filterContainersDisplayElements.forEach(($filterContainersDisplayElement) => {
          $filterContainersDisplayElement.innerHTML = "";
        });
      } else {
        mobileFilterDisplay.classList.add(c.cls.hide);
      }
    }
  }

  /**
   * Add Events
   */
  function addEvents() {
    __.addEvent({
      id: $filtersTrigger,
      event: "click",
      fn: toggleFiltersDrawer
    });

    __.addEvent({
      id: c.dom.drawerClose,
      event: "click",
      fn: toggleFiltersDrawer
    });

    __.addEvent({
      id: overlay,
      event: "click",
      fn: deskDrawerSetup
    });

    __.addEvent({
      id: $toolbar,
      event: "click",
      className: c.dom.filterGroup,
      fn: handleFilterGroupToggle
    });

    __.addEvent({
      id: c.dom.filterForm,
      event: "submit",
      fn: interceptFormSubmit
    });

    __.addEvent({
      id: c.dom.desktopFilterForm,
      event: "submit",
      fn: interceptFormSubmit
    });

    __.addEvent({
      id: c.dom.filterForm,
      event: "change",
      fn: onFilterChange
    });

    __.addEvent({
      id: c.dom.desktopFilterForm,
      event: "change",
      fn: onFilterChange
    });

    // Add event listener for sort selection
    const sortInputs = document.querySelectorAll('input[name="sort_by"]');
    sortInputs.forEach(input => {
      __.addEvent({
        id: input,
        event: "change",
        fn: updateSortLabel
      });
    });

    __.addEvent({
      id: $sidebarBtn,
      event: "click",
      fn: toggleFiltersSidebar
    });

    $sidebarBtnAbs.forEach(($btn) => {
      __.addEvent({
        id: $btn,
        event: "click",
        fn: toggleFiltersSidebar
      });
    });

    $desktopClearAllButton.forEach(($btn) => {
      __.addEvent({
        id: $btn,
        event: "click",
        fn: clearAllFilters
      });
    });
  }

  /**
   * Intercept Form Submit
   * @param {Object} e - submit event
   */
  function interceptFormSubmit(e) {
    e.preventDefault();
    if (window.location.pathname === "/search") {
      const activeParams = setUrlParams();
      const newPath = `${window.location.href}${activeParams}`;
      window.history.replaceState(null, "", newPath);
      window.location.reload();
    } else {
      const queryParams = setUrlParams();
      const newPath = `${window.location.pathname}?${queryParams}#collection`;
      window.history.replaceState(null, "", newPath);
      new Promise((resolve) => {
        fetchFilteredProducts(queryParams);
        resolve();
      }).then(() => {
        toggleFiltersDrawer();
        setActiveFiltersSize();
        formModified = false;
        updateMobileButtonUX();
      });
    }
  }

  /**
   * Remove Desktop Form
   */
  function removeDesktopForm() {
    if ($filterForm && $filterGroupContainer && !$filterForm.contains($filterGroupContainer)) {
      $filterForm.insertBefore($filterGroupContainer, $filterForm.lastElementChild);
    }
    if ($desktopFilterForm && $desktopFilterForm.parentNode) {
      $desktopFilterForm.parentNode.removeChild($desktopFilterForm);
    }
  }

  /**
   * Add Desktop Form
   */
  function addDesktopForm() {
    if ($filterForm && $filterGroupContainer && $filterForm.contains($filterGroupContainer)) {
      $filterForm.removeChild($filterGroupContainer);
    }
    if ($desktopFilterForm && $productsContainer
      && !$productsContainer.contains($desktopFilterForm)) {
      $productsContainer.insertBefore($desktopFilterForm, $productsContainer.firstChild);
    }
  }

  /**
   * Toggle Filters Sidebar
   * @param {event} e - click event
   */
  function toggleFiltersSidebar(e) {
    e.preventDefault();
    if (__.hasClass($desktopFilterForm, c.cls.hide)) {
      __.removeClass($desktopFilterForm, c.cls.hide);
      __.addClass($productsGrid, c.cls.productsPerRowThree);
      __.removeClass($productsGrid, c.cls.productsPerRowFour);
      __.addClass($sidebarBtn, c.cls.hide);
      $sidebarBtnAbs.forEach(($btn) => __.removeClass($btn, c.cls.hide));
    } else {
      __.addClass($desktopFilterForm, c.cls.hide);
      __.removeClass($productsGrid, c.cls.productsPerRowThree);
      __.addClass($productsGrid, c.cls.productsPerRowFour);
      __.removeClass($sidebarBtn, c.cls.hide);
      $sidebarBtnAbs.forEach(($btn) => __.addClass($btn, c.cls.hide));
    }

    window.dispatchEvent(new CustomEvent("product-view-changed"));
  }

  /**
   * Set URL Params
   */
  function setUrlParams() {
    let url = "";
    filters.forEach((filter) => {
      url += (url ? "&" : "") + filter;
    });
    return url;
  }

  /**
   * Update active color filters in SDG global object
   */
  function updateActiveColorFilters() {
    // Get all checked color filter checkboxes
    const $colorFilterCheckboxes = document.querySelectorAll('.js-filter-group-colors input[type="checkbox"]');
    const activeColorFilters = [];
    
    $colorFilterCheckboxes.forEach(($checkbox) => {
      if ($checkbox.checked) {
        activeColorFilters.push($checkbox.value);
      }
    });
    
    // Update the global SDG object
    window.SDG = window.SDG || {};
    SDG.activeColorFilters = activeColorFilters;
  }

  /**
   * On filter change
   * @param {event} e - change event
   */
  function onFilterChange(e) {
    formModified = true;
    if (e.target.type === "range") {
      const $sizeFilterLabels = [...document.querySelectorAll(".js-filter-sidebar-size-filter-label")];
      const $sizeFilterHiddenCheckboxes = [...document.querySelectorAll('input[name="filter.v.option.size')];
      e.preventDefault();

      $sizeFilterLabels.forEach(($sizeFilterLabel) => {
        if ($sizeFilterLabel.dataset.sizeIndex === e.target.value) {
          $sizeFilterLabel.classList.add(c.cls.active);
        } else {
          $sizeFilterLabel.classList.remove(c.cls.active);
        }
      });

      $sizeFilterHiddenCheckboxes.forEach(($sizeFilterHiddenCheckbox) => {
        if ($sizeFilterHiddenCheckbox.dataset.sizeIndex === e.target.value) {
          const { name, value } = $sizeFilterHiddenCheckbox;
          $sizeFilterHiddenCheckbox.checked = true;
          addUrlParam(name, value);
        } else {
          const { name, value } = $sizeFilterHiddenCheckbox;
          $sizeFilterHiddenCheckbox.checked = false;
          removeUrlParam(name, value);
        }
      });
      return;
    }

    const { name, value } = e.target;
    const isFacetActive = e.target.checked;

    if (isFacetActive) {
      addUrlParam(name, value);
    } else {
      removeUrlParam(name, value);
    }
  }

  /**
   * Sync checkbox states from one form to another
   */
  function syncCheckboxStates(source, target) {
    const sourceCheckboxes = source.querySelectorAll('input[type="checkbox"]');
    sourceCheckboxes.forEach((sourceCheckbox) => {
      const escapedValue = sourceCheckbox.value.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
      const targetCheckbox = target.querySelector(`input[type="checkbox"][name="${sourceCheckbox.name}"][value="${escapedValue}"]`);
      if (targetCheckbox) {
        targetCheckbox.checked = sourceCheckbox.checked;
      }
    });
  }

  /**
   * Mobile Drawer Setup
   */
  function mobileDrawerSetup() {
    if (view === "desktop") {return;}
    $filterGroups.forEach(($filterGroup) => {
      __.addClass($filterGroup, c.cls.open);
      $filterGroup.setAttribute("open", "");
    });
  }

  /**
   * Desk Drawer Setup
   */
  function deskDrawerSetup(toggle) {
    if (view !== "desktop") {return;}

    $mobileFilterGroups.forEach(($filterGroup) => {
      __.removeClass($filterGroup, c.cls.open);
      __.removeClass(overlay, c.cls.open);
      $filterGroup.removeAttribute("open", "");
    });
    if (!toggle) {
      $desktopFilterGroups.forEach(($filterGroup) => {
        __.addClass($filterGroup, c.cls.open);
        $filterGroup.setAttribute("open", "");
      });
    }
  }

  /**
   * Handle Filter Group Toggle
   */
  function handleFilterGroupToggle(e) {
    if (!e?.currentTarget) {return;}
    if (__.hasClass(e.currentTarget, c.cls.open)) {
      deskDrawerSetup(true);
      return;
    }

    deskDrawerSetup(true);
    __.addClass(e.currentTarget, c.cls.open);
    __.addClass(overlay, c.cls.open);
  }

  /**
   * Toggle Filters Drawer
   */
  function toggleFiltersDrawer() {
    $filtersWrapper.classList.toggle(c.cls.closed);
    document.body.classList.toggle(c.cls.bodyNoScroll);
    trapFocus($filtersWrapper);
    mobileDrawerSetup();
  }

  /**
   * Remove Existing Sort Params
   */
  function removeExistingSortParams() {
    filters.forEach((filter) => {
      const [name, value] = filter.split("=");
      if (name === "sort_by") {
        filters.delete(`${name}=${value}`);
      }
    });
  }

  /**
   * Responsive
   */
  function responsive() {
    __.mq({
      view: "desktop",
      callback: () => {
        if (view !== "desktop") {
          syncCheckboxStates($filterGroupContainer, $desktopFilterForm);
          view = "desktop";
          deskDrawerSetup();
          $desktopAppendWrapper.appendChild($filtersWrapper);
          __.removeClass($filtersWrapper, c.cls.closed);
          addDesktopForm();
          setActiveFiltersSize();
        }
      }
    });

    __.mq({
      view: "mobile",
      callback: () => {
        if (view !== "mobile") {
          syncCheckboxStates($desktopFilterForm, $filterGroupContainer);
          __.removeClass(overlay, c.cls.open);
          view = "mobile";
          document.body.appendChild($filtersWrapper);
          __.addClass($filtersWrapper, c.cls.closed);
          trapFocus($filtersWrapper);
          removeDesktopForm();
          setActiveFiltersSize();
          updateMobileButtonUX();
        }
      }
    });
  }

  /**
   * Update Mobile Button UX
   */
  function updateMobileButtonUX() {
    const checkedInputs = $filtersWrapper.querySelectorAll('input[type="checkbox"]:checked');
    if (!$appliedCount) {return;}
    const clearBtnMobile = document.querySelector(`.${c.dom.clearAllMobile}`);
    const filterCount = checkedInputs.length;
    __.removeClass(clearBtnMobile, c.cls.hide);
    if (filterCount > 0) {
      $appliedCount.innerHTML = `Apply (${filterCount}) Filters`;
      $appliedCount.removeAttribute("disabled");
    } else if (formModified) {
      $appliedCount.innerHTML = "Update";
      $appliedCount.removeAttribute("disabled");
    } else {
      $appliedCount.innerHTML = "Select Filters";
      $appliedCount.setAttribute("disabled", "");
    }
  }

  /**
   * Fetch filtered products via AJAX
   * @param {String} queryString - The query string to append to the URL
  */
  function fetchFilteredProducts(queryString) {
    const url = `${window.location.pathname}?${queryString}&view=ajax`;
    
    __.ajax({
      type: "GET",
      url,
      error: (error) => {
        console.error("Error fetching filtered products:", error);
      },
      success: (data) => {
        if (!data) {return;}
        
        const $newCollection = new DOMParser().parseFromString(data, "text/html");
        const $newProductsGrid = $newCollection.getElementById(c.dom.productsGrid);
        const $newPagination = $newCollection.querySelector(c.dom.collectionPagination);
        
        if ($productsGrid && $newProductsGrid) {
          updateActiveColorFilters();
          
          // Update products grid
          $productsGrid.innerHTML = $newProductsGrid.innerHTML;

         // Update pagination links to include current filters
        if ($newPagination) {
          const $currentPagination = document.querySelector(c.dom.collectionPagination);
          if ($currentPagination) {
            $currentPagination.innerHTML = $newPagination.innerHTML;
          }
        }
          
          // Reinitialize product items with updated SDG.activeColorFilters
          productItemApp({
            dom: {
              parent: "collection"
            }
          });
          collectionQuickview();
          
          // Update product count if available
          const $newCount = $newCollection.querySelector(".js-search-results-count");
          const $currentCount = document.querySelector(".js-search-results-count");
          if ($newCount && $currentCount) {
            $currentCount.innerHTML = $newCount.innerHTML;
          }
          setActiveFiltersSize();
          scrollToCollectionTop();
          window.dispatchEvent(new CustomEvent("productsLoaded"));
        }
      }
    });
  }

  /**
   * Add URL Param
   * @param {String} key
   * @param {String} value
   */
  function addUrlParam(key, value) {
    if (view === "desktop") {
      const searchParams = new URLSearchParams(window.location.search);

      if (searchParams.has("sort_by")) {
        searchParams.delete("sort_by");
      }
      searchParams.append(key, value);
      const newPath = `${window.location.pathname}?${searchParams.toString()}#collection`;
      window.history.replaceState(null, "", newPath);
      
      // Fetch filtered products via AJAX
      fetchFilteredProducts(searchParams.toString());
    } else {
      removeExistingSortParams();
      filters.add(`${key}=${encodeURIComponent(value)}`);
      updateMobileButtonUX();
    }
  }

  /**
   * Remove URL param
   * @param {String} key
   * @param {String} value
   */
  function removeUrlParam(key, value) {
    if (view === "desktop") {
      const searchParams = new URLSearchParams(window.location.search);
      const entries = searchParams.getAll(key);
      const newEntries = entries.filter((entry) => entry !== value);

      searchParams.delete(key);
      newEntries.forEach((newEntry) => searchParams.append(key, newEntry));
      const newPath = `${window.location.pathname}?${searchParams.toString()}#collection`;
      window.history.replaceState(null, "", newPath);
      
      // Fetch filtered products via AJAX
      fetchFilteredProducts(searchParams.toString());
    } else {
      filters.delete(`${key}=${encodeURIComponent(value)}`);
      updateMobileButtonUX();
    }
  }


  function initSizeRangeInput() {
    const $sizeRangeInput = document.querySelector(".filter-group-display__range-input");

    if (!$sizeRangeInput) {return;}

    const $sizeFilterHiddenCheckboxes = [...document.querySelectorAll('input[name="filter.v.option.size')] || [];
    const $sizeFilterLabels = [...document.querySelectorAll(".js-filter-sidebar-size-filter-label")] || [];
    const $sizeFilterDescriptions = [...document.querySelectorAll(".js-filter-sidebar-size-filter-description")] || [];
    const $activeSizeFilter = $sizeFilterHiddenCheckboxes?.find(({ checked }) => checked) || null;
    const sizeIndex = $activeSizeFilter?.dataset?.sizeIndex || null;

    if ($sizeFilterLabels?.length > 0 && sizeIndex) {
      $sizeFilterLabels?.forEach(($sizeFilterLabel) => {
        if ($sizeFilterLabel?.dataset?.sizeIndex === sizeIndex) {
          $sizeFilterLabel.classList.add(c.cls.active);
        } else {
          $sizeFilterLabel.classList.remove(c.cls.active);
        }
      });
    }

    if ($sizeFilterDescriptions?.length > 0 && sizeIndex) {
      $sizeFilterDescriptions?.forEach(($sizeFilterDescription) => {
        if ($sizeFilterDescription.dataset.sizeIndex === sizeIndex) {
          $sizeFilterDescription.classList.add(c.cls.active);
        } else {
          $sizeFilterDescription.classList.remove(c.cls.active);
        }
      });
    }

    $sizeRangeInput.value = $activeSizeFilter?.dataset?.sizeIndex || 0;
  }

  function clearAllFilters(e) {
    e.preventDefault();

    const searchParams = new URLSearchParams(window.location.search);

    searchParams.forEach((value, key) => {
      if (!key.includes("filter")) {
        return;
      }

      searchParams.delete(key);
      const paramsString = searchParams.toString() ? `?${searchParams.toString()}` : "";
      const newPathWithParams = `${window.location.pathname}${paramsString}#collection`;
      window.history.replaceState(null, "", newPathWithParams);
      const $filterContainer = getActiveFilterContainer();
      const activeFilters = $filterContainer ? $filterContainer.querySelectorAll('input[type="checkbox"]:checked') : [];
      activeFilters.forEach((activeFilter) => {
        activeFilter.checked = false;
      });
      // Fetch filtered products via AJAX
      new Promise((resolve) => {
        fetchFilteredProducts(searchParams.toString());
        resolve();
      }).then(() => {
        setActiveFiltersSize();
        formModified = false;
        updateMobileButtonUX();
      });
    });
  }

  /**
   * Get sort display text
   * @param {string} value - sort value
   * @returns {string} display text
   */
  function getSortDisplayText(value) {
    switch (value) {
      case "manual":
        return "Featured";
      case "best-selling":
        return "Most Popular";
      case "created-descending":
        return "Newest";
      case "title-ascending":
        return "Alphabetical A -> Z";
      case "title-descending":
        return "Alphabetical Z -> A";
      case "price-ascending":
        return "Price Low -> High";
      case "price-descending":
        return "Price High -> Low";
      default:
        return value;
    }
  }

  /**
   * Update sort label text
   * @param {Event} event - change event
   */
  function updateSortLabel(event) {
    const { value } = event.target;
    const sortLabel = document.querySelector(".filter-group-summary__inner .hide-mobile");
    if (sortLabel) {
      sortLabel.textContent = getSortDisplayText(value);
    }
    formModified = true;
    updateMobileButtonUX();
  }

  return init();
}

export default collectionFilters;
